import React, { useState, useEffect } from "react";
import {
  Image,
  Container,
  Col,
  Row,
  Button,
  InputGroup,
  img,
} from "react-bootstrap";
import Form from "react-bootstrap/Form";
import { Link, useNavigate } from "react-router-dom";
// Require Editor JS files.
import "froala-editor/js/froala_editor.pkgd.min.js";
import arrowDown from "../../assets/arrow-down.png";
// Require Editor CSS files.
import "froala-editor/css/froala_style.min.css";
import "froala-editor/css/froala_editor.pkgd.min.css";
import "froala-editor/js/plugins.pkgd.min.js";
import { MdClose, MdKeyboardArrowDown } from "react-icons/md";
import FroalaEditor from "react-froala-wysiwyg";
import { BulkNotifyDropdown } from "../API/Communications/BulkNotifyDropdown";
import Loader from "../Loader/Loader";
import swal from "sweetalert";
import { BulkNotifyBusinessList } from "../API/Communications/BulkNotifyBusinessList";
import { TableListApi } from "./../API/Communications/TableList";
import { EditTemplateName } from "../API/Communications/EmailTemplateName";
import { SaveNotify } from "../API/Communications/SaveNotify";
import OutsideClickHandler from "./OutsideClickHandler";
import NoDataText from "../NoDataText";
import { FroalaTextEditor } from "./../FroalaEditor/FroalaTextEditor";
import { FroalaDefault } from "./../../Utils/FroalaDefaultText";
import { CustomerList } from "../API/Communications/CustomerList";
import { set } from "date-fns";
import { sendCustomerBulkNotifyApi } from "../API/Communications/SendCustomerBulkNotify";

export const BulkNotify = () => {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [recipientType, setrecipientType] = useState([
    {
      id: 1,
      type: "Bussiness",
    },
    {
      id: 2,
      type: "Customer",
    },
  ]);

  // customer List
  const [CustomerData, setCustomerData] = useState([]);
  const [recipientValue, setRecipientValue] = useState(1);

  const [bussinessStatus, setbussinessStatus] = useState([]);
  const [bussinessCategory, setbussinessCategory] = useState([]);
  const [EmailTemplate, setEmailTemplate] = useState([]);
  const [EmailSubject, setEmailSubject] = useState("");
  const [businessList, setBusinessList] = useState([]);

  // onchange
  const [statusValue, setStatusValue] = useState("");
  const [categoryValue, setcategoryValue] = useState("");
  const [emailValue, setemailValue] = useState("");
  const [TemplateContent, setTemplateContent] = useState(FroalaDefault.text);
  // err
  const [statusValueErr, setStatusValueErr] = useState("");
  const [categoryValueErr, setcategoryValueErr] = useState("");
  const [emailValueErr, setemailValueErr] = useState("");
  const [EmailSubjectValueErr, setEmailSubjectValueErr] = useState("");
  const [TemplateContentErr, setTemplateContentErr] = useState("");
  const [businessListErr, setbusinessListErr] = useState("");
  const [recipientValueErr, setRecipientValueErr] = useState("");
  const [customerListErr, setCustomerListErr] = useState("");

  const [ShowBussinessList, setShowBussinessList] = useState(false);
  const [ShowBussinessCategory, setShowBussinessCategory] = useState(false);
  const [ShowCustomerList, setShowCustomerList] = useState(false);

  const [isCheckAll, setIsCheckAll] = useState(false);
  const [isCheck, setIsCheck] = useState([]);
  const [isCheckvalue, setisCheckvalue] = useState([]);

  const [isCheckAllCustomer, setIsCheckAllCustomer] = useState(false);
  const [isCheckCustomer, setIsCheckCustomer] = useState([]);
  const [isCheckvalueCustomer, setisCheckvalueCustomer] = useState([]);

  const [isCheckAllCategory, setIsCheckAllCategory] = useState(false);
  const [isCheckCategory, setIsCheckCategory] = useState([]);
  const [isCheckvalueCategory, setisCheckvalueCategory] = useState([]);

  useEffect(() => {
    setLoading(true);
    ApiLoad();
    // ApiBusiness();
    ApiEmailTemplate();
  }, []);

  const ApiLoad = async () => {
    const cityId = localStorage.getItem("cityId");
    const data = {
      user_id: parseInt(cityId),
    };
    const coupondetailData = await BulkNotifyDropdown(data, () => {
      navigate("/");
    });
    if (coupondetailData.success === false) {
      setLoading(false);
    } else if (coupondetailData.status === 429) {
      setLoading(true);
      swal({
        text: `${coupondetailData.message}`,
        icon: "error",
        buttons: "Ok",
        dangerMode: false,
      });
    } else {
      setbussinessStatus(coupondetailData.data.business_stat);
      setbussinessCategory(coupondetailData.data.business_cat);
      setLoading(false);
    }
  };

  const ApiBusiness = async (statusId, cat_id) => {
    const cityId = localStorage.getItem("cityId");
    const data = {
      user_id: parseInt(cityId),
      status_id: parseInt(statusId),
      business_cat: cat_id,
    };
    const res = await BulkNotifyBusinessList(data, () => {
      navigate("/");
    });
    if (res.status === 429) {
      swal({
        // title: "Success!",
        title: `${res.message} `,
        icon: "error",
        buttons: "Ok",
      });
      setLoading(true);
    } else if (res == false) {
      setLoading(false);
    } else {
      if (res.success == false) {
        setBusinessList([]);
        setLoading(false);
      } else {
        setBusinessList(res.data);
        setLoading(false);
      }
    }
  };
  const customerList = async () => {
    let data = { user_type: "customer" };
    const CustomerData = await CustomerList(data, () => {
      navigate("/");
    });
    if (CustomerData.status === 200) {
      setCustomerData(CustomerData.data);
    }
  };
  useEffect(() => {
    customerList();
  }, []);

  useEffect(() => {
    ApiBusiness(statusValue, isCheckCategory);
  }, [statusValue, isCheckCategory]);

  // TableListApi
  const ApiEmailTemplate = async () => {
    const cityId = localStorage.getItem("cityId");
    const data = {
      user_id: parseInt(cityId),
    };
    const res = await EditTemplateName(data, () => {
      navigate("/");
    });
    if (res.status === 429) {
      setLoading(true);
      swal({
        // title: "Error!",
        title: `${res.message}`,
        icon: "error",
        buttons: "OK",
      });
    } else if (res.success === false) {
      setLoading(false);
    } else {
      setLoading(false);
      setEmailTemplate(res.data);
    }
  };

  // checkbox - th
  const handleSelectAll = (e) => {
    setIsCheckAll(!isCheckAll);
    setIsCheck(businessList.map((li) => li.business_id));
    setisCheckvalue(businessList.map((li) => li.business_email));
    if (isCheckAll) {
      setIsCheck([]);
      setisCheckvalue([]);
    }
  };

  // checkbox customer - th
  const handleSelectAllCustomer = (e) => {
    setIsCheckAllCustomer(!isCheckAllCustomer);
    setIsCheckCustomer(CustomerData.map((li) => li.eu_id));
    setisCheckvalueCustomer(CustomerData.map((li) => li.eu_email));
    if (isCheckAllCustomer) {
      setIsCheckCustomer([]);
      setisCheckvalueCustomer([]);
    }
  };

  // checkbox - tr
  const handleClickCustomer = (e, key) => {
    const { checked } = e.target;
    setIsCheckCustomer([...isCheckCustomer, CustomerData[key].eu_id]);
    setisCheckvalueCustomer([
      ...isCheckvalueCustomer,
      CustomerData[key].eu_email,
    ]);
    if (!checked) {
      setIsCheckCustomer(
        isCheckCustomer.filter((item) => item !== CustomerData[key].eu_id)
      );
      setisCheckvalueCustomer(
        isCheckvalueCustomer.filter(
          (item) => item !== CustomerData[key].eu_email
        )
      );
    }
  };

  // checkbox - tr
  const handleClick = (e, key) => {
    const { checked } = e.target;
    setIsCheck([...isCheck, businessList[key].business_id]);
    setisCheckvalue([...isCheckvalue, businessList[key].business_email]);
    if (!checked) {
      setIsCheck(
        isCheck.filter((item) => item !== businessList[key].business_id)
      );
      setisCheckvalue(
        isCheckvalue.filter((item) => item !== businessList[key].business_email)
      );
    }
    // console.log(isCheck.length + 1,businessList.length)
    // if(isCheck.length + 1 == businessList.length){
    //   setIsCheckAll(true);
    // }
    // if(isCheck.length - 1 != businessList.length){
    //   setIsCheckAll(false);
    // }
  };

  // delete customer
  const removeTagCustomer = (e, key) => {
    setisCheckvalue(isCheckvalueCustomer.filter((el, i) => i !== key));
    isCheckvalueCustomer.splice(key, 1);
    // if(isCheckvalue == 0){}
    setIsCheckCustomer(isCheckCustomer.filter((el, i) => i !== key));
    setIsCheckAllCustomer(false);
    // setShows(false)
  };

  // delete
  const removeTag = (e, key) => {
    setisCheckvalue(isCheckvalue.filter((el, i) => i !== key));
    isCheckvalue.splice(key, 1);
    // if(isCheckvalue == 0){}
    setIsCheck(isCheck.filter((el, i) => i !== key));
    setIsCheckAll(false);
    // setShows(false)
  };

  // delete-cat-dropdown
  const removeTagCategory = (e, key) => {
    setisCheckvalueCategory(isCheckvalueCategory.filter((el, i) => i !== key));
    isCheckvalueCategory.splice(key, 1);
    // if(isCheckvalue == 0){}
    setIsCheckCategory(isCheckCategory.filter((el, i) => i !== key));
    setIsCheckAllCategory(false);
    // setShows(false)
  };

  // checkbox - tr-cat-dropdown
  const handleClickCategory = (e, key) => {
    const { checked } = e.target;
    setIsCheckCategory([
      ...isCheckCategory,
      bussinessCategory[key].category_id,
    ]);
    setisCheckvalueCategory([
      ...isCheckvalueCategory,
      bussinessCategory[key].category_name,
    ]);
    setcategoryValueErr(false);
    if (!checked) {
      setIsCheckCategory(
        isCheckCategory.filter(
          (item) => item !== bussinessCategory[key].category_id
        )
      );
      setisCheckvalueCategory(
        isCheckvalueCategory.filter(
          (item) => item !== bussinessCategory[key].category_name
        )
      );
    }
  };

  // checkbox - th-cat-dropdown
  const handleSelectAllCategory = (e) => {
    setIsCheckAllCategory(!isCheckAllCategory);
    setIsCheckCategory(bussinessCategory.map((li) => li.category_id));
    setisCheckvalueCategory(bussinessCategory.map((li) => li.category_name));
    if (isCheckAllCategory) {
      setIsCheckCategory([]);
      setisCheckvalueCategory([]);
    }
  };

  const SaveHandler = async (e) => {
    e.preventDefault();
    setLoading(true);

    if (statusValue.length == 0) {
      setStatusValueErr(true);
      setLoading(false);
    }

    if (isCheckCategory.length == 0) {
      setcategoryValueErr(true);
      setLoading(false);
    }
    if (TemplateContent == FroalaDefault.text) {
      setTemplateContentErr(true);
      setLoading(false);
    }
    if (isCheck.length == 0) {
      setbusinessListErr(true);
      setLoading(false);
    }

    if (emailValue.length == 0) {
      setemailValueErr(true);
      setLoading(false);
    }
    if (
      emailValue.length &&
      isCheck.length &&
      isCheckCategory.length &&
      statusValue.length != 0
    ) {
      setLoading(true);
      const cityId = localStorage.getItem("cityId");
      const data = {
        user_id: parseInt(cityId),
        template_id: parseInt(emailValue),
        b_status: parseInt(statusValue),
        category_id: isCheckCategory,
        email_subject: EmailSubject,
        business_user_id: isCheck,
        email_content: TemplateContent,
      };
      const Response = await SaveNotify(data, () => {
        navigate("/");
      });
      setLoading(false);
      if (Response.status === 429) {
        setLoading(true);
        swal({
          text: `${Response.message}`,
          icon: "warning",
          buttons: "Ok",
          dangerMode: false,
        });
      } else if (Response == false) {
        swal({
          text: `${NoDataText.InternalErr}`,
          icon: "error",
          buttons: "Ok",
          dangerMode: false,
        });
      } else {
        if (Response.status == 404) {
          swal({
            text: `${Response.message}`,
            icon: "warning",
            buttons: "Ok",
            dangerMode: false,
          });
        } else {
          swal({
            title: `${Response.message}`,
            icon: "success",
            buttons: "OK",
            dangerMode: false,
          }).then((success) => {
            if (success) {
              setTimeout(() => {
                window.location.reload(false);
              }, 1000);
            }
          });
        }
      }
    }
  };

  const CancelHandler = () => {
    window.location.reload(false);
  };

  const handleEmailTemplate = async (e) => {
    // console.log(e.target.value)
    // setLoading(true);
    setemailValue(e.target.value);
    setemailValueErr(false);
    const cityId = localStorage.getItem("cityId");
    const data = {
      user_id: parseInt(cityId),
      template_id: e.target.value,
    };
    const coupondetailData = await TableListApi(data, () => {
      navigate("/");
    });
    if (coupondetailData.status === 429) {
      setLoading(true);
      swal({
        text: `${coupondetailData.message}`,
        icon: "error",
        buttons: "Ok",
        dangerMode: false,
      });
    }
    // setLoading(false);
    else if (coupondetailData.success === false) {
      swal({
        text: `${coupondetailData.message}`,
        icon: "warning",
        buttons: "Ok",
        dangerMode: false,
      });
      swal.stopLoading();
      swal.close();
    } else {
      setEmailSubject(coupondetailData.data[0].email_subject);
      setTemplateContent(coupondetailData.data[0].template_content);
    }
  };

  useEffect(() => {
    if (isCheck.length != 0) {
      setbusinessListErr(false);
    }
  }, [isCheck]);

  useEffect(() => {
    if (isCheckCustomer.length != 0) {
      setCustomerListErr(false);
    }
  }, [isCheckCustomer]);

  const saveCustomerHandler = async (e) => {
    e.preventDefault();
    setLoading(true);

    if (TemplateContent == FroalaDefault.text) {
      setTemplateContentErr(true);
      setLoading(false);
    }
    if (isCheckCustomer.length == 0) {
      setCustomerListErr(true);
      setLoading(false);
    }

    if (emailValue.length == 0) {
      setemailValueErr(true);
      setLoading(false);
    }
    if (emailValue.length && isCheckCustomer.length) {
      const payload = {
        template_id: parseInt(emailValue),
        email_subject: EmailSubject,
        eu_id: isCheckCustomer,
        email_content: TemplateContent,
      };
      const SendcustomerBulkData = await sendCustomerBulkNotifyApi(payload);
      setLoading(false);
      if (SendcustomerBulkData.status === 429) {
        setLoading(true);
        swal({
          text: `${SendcustomerBulkData.message}`,
          icon: "warning",
          buttons: "Ok",
          dangerMode: false,
        });
      } else if (SendcustomerBulkData == false) {
        swal({
          text: `${NoDataText.InternalErr}`,
          icon: "error",
          buttons: "Ok",
          dangerMode: false,
        });
      } else {
        if (SendcustomerBulkData.status == 404) {
          swal({
            text: `${SendcustomerBulkData.message}`,
            icon: "warning",
            buttons: "Ok",
            dangerMode: false,
          });
        } else {
          swal({
            title: `${SendcustomerBulkData.message}`,
            icon: "success",
            buttons: "OK",
            dangerMode: false,
          }).then((success) => {
            if (success) {
              setTimeout(() => {
                window.location.reload(false);
              }, 1000);
            }
          });
        }
      }
    }
  };
  return (
    <>
      {loading ? <Loader /> : ""}
      <Row>
        <Col>
          {/* <Form
            // onSubmit={SaveHandler}
            className="formmain mx-0 mt-4 signin-row profile-form pb-4"
          > */}
          <Row className="signin-row">
            <Col md="6" className="">
              <Form.Group className="mb-4" controlId="formBasicEmail">
                <Form.Label className="form-label-custom">
                  Audience
                  <span className="star-required">*</span>
                </Form.Label>
                <Form.Select
                  aria-label="Default select example"
                  className="custom-select select-custom email-sub form-control"
                  onChange={(e) => {
                    setRecipientValue(e.target.value);
                    setRecipientValueErr(false);
                  }}
                  value={recipientValue}
                >
                  {/* <option disabled>Select Business Status</option> */}
                  <option key="blankChoice" hidden value>
                    {" "}
                    Select Audience
                  </option>
                  {recipientType.map((i, k) => {
                    return (
                      <option value={i.id}>
                        {" "}
                        <Form.Check
                          aria-label="option 1"
                          className="orange-checkbox"
                        />
                        {i.type}
                      </option>
                    );
                  })}
                </Form.Select>
                {recipientValueErr && (
                  <p style={{ color: "red" }}>*Please select audience!</p>
                )}
              </Form.Group>

              {/* <ErrorLabel ErrorDisplay={errDisplayLastName} /> */}
            </Col>
            {recipientValue == 1 && (
              <>
                <Col md="6" className="">
                  <Form.Group className="mb-4" controlId="formBasicEmail">
                    <Form.Label className="form-label-custom">
                      Business Status <span className="star-required">*</span>
                    </Form.Label>

                    <Form.Select
                      aria-label="Default select example"
                      className="custom-select email-sub form-control"
                      onChange={(e) => {
                        setStatusValue(e.target.value);
                        setStatusValueErr(false);
                      }}
                    >
                      {/* <option disabled>Select Business Status</option> */}
                      <option key="blankChoice" hidden value>
                        {" "}
                        Select Business Status
                      </option>
                      {bussinessStatus.map((i, k) => {
                        return (
                          <option value={i.business_status_id}>
                            {" "}
                            <Form.Check
                              aria-label="option 1"
                              className="orange-checkbox"
                            />
                            {i.business_status}
                          </option>
                        );
                      })}
                    </Form.Select>
                    {statusValueErr && (
                      <p style={{ color: "red" }}>
                        *Please select business status!
                      </p>
                    )}
                  </Form.Group>

                  {/* <ErrorLabel ErrorDisplay={errDisplayLastName} /> */}
                </Col>
                {/* duplicate */}
                <Col md="6" className="business-list-main">
                  <Form.Group className="mb-4" controlId="formBasicEmail">
                    <Form.Label className="form-label-custom">
                      Business Category
                      <span className="star-required">*</span>
                    </Form.Label>

                    {isCheckCategory.length != 0 ? (
                      // {/* list-design */}
                      <div class="multiselect bulk-notify">
                        <div
                          className="sel_items"
                          style={{ cursor: "pointer" }}
                          onClick={() =>
                            setShowBussinessCategory(!ShowBussinessCategory)
                          }
                        >
                          {isCheckvalueCategory.map((eachItem, key) => {
                            return (
                              <div
                                className="save-item"
                                style={{ backgroundColor: "#EFEFEF" }}
                                key={key}
                              >
                                <span style={{ color: "rgb(230, 97, 0)" }}>
                                  {eachItem}
                                </span>
                                <MdClose
                                  style={{ marginLeft: 8 }}
                                  className="delete_item"
                                  onClick={(e) => removeTagCategory(e, key)}
                                />
                              </div>
                            );
                          })}
                        </div>
                        <img
                          className="arrowDown_dropBulk"
                          src={arrowDown}
                          style={{ cursor: "pointer" }}
                        />
                      </div>
                    ) : (
                      <form>
                        <div
                          class="multiselect bulk-notify "
                          onClick={() =>
                            setShowBussinessCategory(!ShowBussinessCategory)
                          }
                          style={{ cursor: "pointer" }}
                        >
                          <img className="arrow-down-bulk" src={arrowDown} />
                          <div class="selectBox bulk-notify">
                            <select>
                              {/* <option disabled>Select Business Category</option> */}
                              <option key="blankChoice" hidden value>
                                Select Business Category
                              </option>
                            </select>
                            <div class="overSelect bulk-notify"></div>
                          </div>
                        </div>
                      </form>
                    )}

                    {/* remove */}
                    {ShowBussinessCategory && (
                      <div
                        id="checkboxes_cat"
                        className="orange-checkbox md-6"
                        onMouseLeave={() => setShowBussinessCategory(false)}
                      >
                        {bussinessCategory.length != 0 ? (
                          <>
                            <label
                              for="one"
                              className="checkbox-label bulk-notify-label"
                            >
                              <input
                                type="checkbox"
                                id="one"
                                className="form-check-input bulk-notify-list"
                                onChange={handleSelectAllCategory}
                                checked={isCheckAllCategory}
                              />
                              Select All
                            </label>

                            {bussinessCategory.map((i, key) => {
                              return (
                                <>
                                  <div className="orange-checkbox">
                                    <label
                                      for={i.category_id}
                                      value={i.category_id}
                                      className="checkbox-label bulk-notify-label"
                                    >
                                      <input
                                        type="checkbox"
                                        id={i.category_id}
                                        className="form-check-input bulk-notify-list"
                                        onChange={(e) =>
                                          handleClickCategory(e, key)
                                        }
                                        checked={isCheckCategory.includes(
                                          i.category_id
                                        )}
                                      />
                                      {i.category_name}
                                    </label>
                                  </div>
                                </>
                              );
                            })}
                          </>
                        ) : (
                          <>
                            <p className="noData">{NoDataText.ErrText}</p>
                          </>
                        )}
                      </div>
                    )}
                    {/* <OutsideClickHandler
                    onOutsideClick={() => {
                      setShowBussinessList(!ShowBussinessList)
                    }}
                  >
                  
                  </OutsideClickHandler> */}

                    {categoryValueErr && (
                      <p style={{ color: "red" }}>
                        *Please select business categories!
                      </p>
                    )}
                  </Form.Group>

                  {/* <ErrorLabel ErrorDisplay={errDisplayLastName} /> */}
                </Col>
              </>
            )}

            {/* bus-cat */}
            {/* <Col md="6" className="">
                <Form.Group className="mb-4" controlId="formBasicEmail">
                  <Form.Label className="form-label-custom">
                    Business Category <span className="star-required">*</span>
                  </Form.Label>
                  <Form.Select
                    aria-label="Default select example"
                    className="custom-select"
                    onChange={(e) => {
                      setcategoryValue(e.target.value)
                      setcategoryValueErr(false)
                    }}
                  >
                    <option>Select Business Category</option>
                    {bussinessCategory.map((i, k) => {
                      return (
                        <option value={i.category_id}>{i.category_name}</option>
                      );
                    })}
                  </Form.Select>
                  {categoryValueErr && (
                    <p style={{ color: "red" }}>
                      *Please select business category!
                    </p>
                  )}
                </Form.Group>
                <ErrorLabel ErrorDisplay={errDisplayLastName} />
              </Col> */}

            {/* end */}
            <Col md="6" className="">
              <Form.Group className="mb-4" controlId="formBasicEmail">
                <Form.Label className="form-label-custom">
                  Email Template <span className="star-required">*</span>
                </Form.Label>
                <Form.Select
                  aria-label="Default select example"
                  className="custom-select dropdown-bulknotify email-sub form-control"
                  onChange={(e) => handleEmailTemplate(e)}
                >
                  <option>Select email template</option>
                  {/* <option key="blankChoice" hidden value>
                      Select Email template
                    </option> */}
                  {EmailTemplate.length > 0 ? (
                    EmailTemplate.map((i, k) => {
                      return (
                        <option value={i.template_id}>{i.template_name}</option>
                      );
                    })
                  ) : (
                    <></>
                  )}
                </Form.Select>
                {emailValueErr && (
                  <p style={{ color: "red" }}>*Please select Email template!</p>
                )}
              </Form.Group>
              {/* <ErrorLabel ErrorDisplay={errDisplayLastName} /> */}
            </Col>
            <Col md="6" className="">
              <Form.Group className="mb-4" controlId="formBasicEmail">
                <Form.Label className="form-label-custom">
                  Email Subject <span className="star-required"></span>
                </Form.Label>
                <InputGroup className="edit-border">
                  <Form.Control
                    type="text"
                    value={EmailSubject}
                    placeholder="Enter Email Subject"
                    className="custom-formcontrol"
                    autoComplete="off"
                    readOnly
                  />
                </InputGroup>
                {/* <ErrorLabel ErrorDisplay={errDisplayLastName} /> */}
              </Form.Group>
            </Col>

            <Col md="6" className="business-list-main">
              <Form.Group className="mb-4" controlId="formBasicEmail">
                <Form.Label className="form-label-custom">
                  {recipientValue == 1 ? "Business" : "Customer"} List{" "}
                  <span className="star-required">*</span>
                </Form.Label>
                {recipientValue == 1 ? (
                  <>
                    {" "}
                    {isCheck.length != 0 ? (
                      // {/* list-design */}
                      <div class="multiselect bulk-notify">
                        <div
                          className="sel_items"
                          style={{ cursor: "pointer" }}
                          onClick={() =>
                            setShowBussinessList(!ShowBussinessList)
                          }
                        >
                          {isCheckvalue.map((eachItem, key) => {
                            return (
                              <div
                                className="save-item"
                                style={{ backgroundColor: "#EFEFEF" }}
                                key={key}
                              >
                                <span style={{ color: "rgb(230, 97, 0)" }}>
                                  {eachItem}
                                </span>
                                <MdClose
                                  style={{ marginLeft: 8 }}
                                  className="delete_item"
                                  onClick={(e) => removeTag(e, key)}
                                />
                              </div>
                            );
                          })}
                        </div>
                        <img
                          className="arrowDown_dropBulk"
                          src={arrowDown}
                          style={{ cursor: "pointer" }}
                        />
                      </div>
                    ) : (
                      <form>
                        <div
                          class="multiselect bulk-notify"
                          onClick={() =>
                            setShowBussinessList(!ShowBussinessList)
                          }
                          style={{ cursor: "pointer" }}
                        >
                          <img className="arrow-down-bulk" src={arrowDown} />
                          <div
                            class="selectBox bulk-notify"
                            // onClick={ShowCheckbox}
                          >
                            <select>
                              <option>
                                Select{" "}
                                {recipientValue == 1 ? "Business" : "Customer"}{" "}
                                List
                              </option>
                            </select>
                            <div class="overSelect bulk-notify select-custom"></div>
                          </div>
                        </div>
                      </form>
                    )}
                  </>
                ) : (
                  <>
                    {isCheckCustomer.length != 0 ? (
                      // {/* list-design */}
                      <div class="multiselect bulk-notify">
                        <div
                          className="sel_items"
                          style={{ cursor: "pointer" }}
                          onClick={() => setShowCustomerList(!ShowCustomerList)}
                        >
                          {isCheckvalueCustomer.map((eachItem, key) => {
                            return (
                              <div
                                className="save-item"
                                style={{ backgroundColor: "#EFEFEF" }}
                                key={key}
                              >
                                <span style={{ color: "rgb(230, 97, 0)" }}>
                                  {eachItem}
                                </span>
                                <MdClose
                                  style={{ marginLeft: 8 }}
                                  className="delete_item"
                                  onClick={(e) => removeTagCustomer(e, key)}
                                />
                              </div>
                            );
                          })}
                        </div>
                        <img
                          className="arrowDown_dropBulk"
                          src={arrowDown}
                          style={{ cursor: "pointer" }}
                        />
                      </div>
                    ) : (
                      <form>
                        <div
                          class="multiselect bulk-notify"
                          onClick={() => setShowCustomerList(!ShowCustomerList)}
                          style={{ cursor: "pointer" }}
                        >
                          <img className="arrow-down-bulk" src={arrowDown} />
                          <div
                            class="selectBox bulk-notify"
                            // onClick={ShowCheckbox}
                          >
                            <select>
                              <option>
                                Select{" "}
                                {recipientValue == 1 ? "Business" : "Customer"}{" "}
                                List
                              </option>
                            </select>
                            <div class="overSelect bulk-notify"></div>
                          </div>
                        </div>
                      </form>
                    )}
                  </>
                )}

                {/* remove */}
                {ShowBussinessList && (
                  <div
                    id="checkboxes"
                    className="orange-checkbox"
                    // onMouseLeave={()=>setShowBussinessList(false)}
                  >
                    {businessList.length != 0 ? (
                      <>
                        <label
                          for="one"
                          className="checkbox-label bulk-notify-label"
                        >
                          <input
                            type="checkbox"
                            id="one"
                            className="form-check-input bulk-notify-list"
                            onChange={handleSelectAll}
                            checked={isCheckAll}
                          />
                          Select All
                        </label>

                        {businessList.map((i, key) => {
                          return (
                            <>
                              <div className="orange-checkbox">
                                <label
                                  for={i.business_id}
                                  value={i.business_id}
                                  className="checkbox-label bulk-notify-label"
                                >
                                  <input
                                    type="checkbox"
                                    id={i.business_id}
                                    className="form-check-input bulk-notify-list"
                                    onChange={(e) => handleClick(e, key)}
                                    checked={isCheck.includes(i.business_id)}
                                  />
                                  {i.business_email}
                                </label>
                              </div>
                            </>
                          );
                        })}
                      </>
                    ) : (
                      <>
                        <p className="noData">{NoDataText.ErrText}</p>
                      </>
                    )}
                  </div>
                )}
                {/* <OutsideClickHandler
                    onOutsideClick={() => {
                      setShowBussinessList(!ShowBussinessList)
                    }}
                  >
                  
                  </OutsideClickHandler> */}

                {/* customer listing */}
                {ShowCustomerList && (
                  <div
                    id="checkboxes"
                    className="orange-checkbox"
                    // onMouseLeave={()=>setShowBussinessList(false)}
                  >
                    {CustomerData?.length != 0 ? (
                      <>
                        <label
                          for="one"
                          className="checkbox-label bulk-notify-label"
                        >
                          <input
                            type="checkbox"
                            id="one"
                            className="form-check-input bulk-notify-list"
                            onChange={handleSelectAllCustomer}
                            checked={isCheckAllCustomer}
                          />
                          Select All
                        </label>

                        {CustomerData.map((i, key) => {
                          return (
                            <>
                              <div className="orange-checkbox">
                                <label
                                  for={i.eu_id}
                                  value={i.eu_id}
                                  className="checkbox-label bulk-notify-label"
                                >
                                  <input
                                    type="checkbox"
                                    id={i.eu_id}
                                    className="form-check-input bulk-notify-list"
                                    onChange={(e) =>
                                      handleClickCustomer(e, key)
                                    }
                                    checked={isCheckCustomer.includes(i.eu_id)}
                                  />
                                  {i.eu_email}
                                </label>
                              </div>
                            </>
                          );
                        })}
                      </>
                    ) : (
                      <>
                        <p className="noData">{NoDataText.ErrText}</p>
                      </>
                    )}
                  </div>
                )}

                {recipientValue == 1 && businessListErr ? (
                  <p style={{ color: "red" }}>*Please select business list!</p>
                ) : customerListErr && recipientValue != 1 ? <p style={{ color: "red" }}>*Please select customer list!</p> : ""}
              
              </Form.Group>

              {/* <ErrorLabel ErrorDisplay={errDisplayLastName} /> */}
            </Col>

            <Col md="12" className="">
              <Form.Group className="mb-4 mt-4" controlId="formBasicEmail">
                <Form.Label className="form-label-custom flex-content">
                  Template Content <span className="star-required">*</span>
                  <p className="info-text-space-f-13">
                    &#40;To start from a new line, please press Shift +
                    Enter.&#41;
                  </p>
                </Form.Label>
                <FroalaTextEditor
                  TemplateContent={TemplateContent}
                  setTemplateContent={setTemplateContent}
                />
                {TemplateContentErr && (
                  <p style={{ color: "red" }}>*Please add template content!</p>
                )}
              </Form.Group>
            </Col>
          </Row>
          <div className="text-center small-btns d-flex mt-4">
            <Link onClick={CancelHandler}>
              <p className="view mt-3" style={{ minWidth: "100px" }}>
                Discard
              </p>
            </Link>
            <Button
              variant="primary"
              type="submit"
              className="green-btn mt-3"
              onClick={(e) => {
                if (recipientValue == 1) {
                  SaveHandler(e);
                } else {
                  saveCustomerHandler(e);
                }
              }}
              style={{ minWidth: "100px" }}
            >
              Send
            </Button>
          </div>
          {/* </Form> */}
        </Col>
      </Row>
    </>
  );
};
